<template>
  <div class="auth-callback">
    <template v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C"/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  created() {
    this.handleCallback(this.$route.query);
  },

  methods: {
    ...mapActions({
      getUserProfile: 'user/getUserProfile',
      getToken: 'user/getToken',
    }),

    async handleCallback(query) {
      const code = query.code;
      const state = query.state;

      await this.getToken(code);

      const lastRoute = sessionStorage.getItem('last_route');
      sessionStorage.removeItem('last_route');

      const routeTo = lastRoute ? lastRoute : { name: 'main' };

      this.$router.replace(routeTo);
    },
  },

  computed: {
    ...mapGetters({
      loading: 'user/loading',
      token: 'user/accessToken',
    }),
  },
};
</script>


<style lang="scss" scoped>
.auth-callback {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
